import './botanist/style';
import FormStructure from './botanist/form_structure';

export default FormStructure;